import { render, staticRenderFns } from "./HotelFlight.vue?vue&type=template&id=47f4acb4&"
import script from "./HotelFlight.vue?vue&type=script&lang=js&"
export * from "./HotelFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports